import {
  Button,
  chakra,
  FormControl,
  FormLabel,
  HStack,
  Image,
  Text,
  useBoolean,
  VStack
} from '@chakra-ui/react'
import { useDropzone } from 'react-dropzone'

type Props = {
  label: string
  imageUrl: string
  onUpload: (file: File) => Promise<void>
  onDelete: VoidFunction
}
export const LogoUploadDropZone: React.FC<Props> = ({
  onUpload,
  onDelete,
  label,
  imageUrl
}) => {
  const [isUploading, { on, off }] = useBoolean()
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'image/gif': []
    },
    onDrop: async (acceptedFiles) => {
      if (acceptedFiles[0].size > 2500000) {
        alert('最大画像サイズの2.5MBを超えています')
        return
      }
      on()
      await onUpload(acceptedFiles[0])
      off()
    }
  })
  return (
    <HStack alignItems={'flex-start'}>
      <FormControl w="240px">
        <FormLabel>{label}</FormLabel>
        <div>
          <section className="container">
            <chakra.div
              {...getRootProps({ className: 'dropzone' })}
              borderWidth="1px"
              borderColor={'gray.400'}
              borderStyle="dashed "
              width={'220px'}
              px={'16px'}
              py={'20px'}
              borderRadius={'2px'}
              _hover={{
                borderColor: 'purple.700',
                cursor: 'pointer',
                transitionDuration: '.2s'
              }}
            >
              <input {...getInputProps()} />
              <chakra.p
                fontSize={'13px'}
                fontWeight={'400'}
                textAlign={'center'}
              >
                ドラッグ＆ドロップか<br></br>
                <chakra.strong fontWeight={'700'} color={'purple.700'}>
                  ファイルを選択
                </chakra.strong>
                してください
                <br></br>
                <br></br>
                対応拡張子 : .jpeg、.png、.gif
              </chakra.p>
            </chakra.div>
          </section>
        </div>
      </FormControl>
      {(isUploading || imageUrl) && (
        <FormControl w="320px">
          <FormLabel>
            {isUploading
              ? '現在アップロード中です'
              : `アップロードした${label}`}
          </FormLabel>
          <div>
            <VStack alignItems={'flex-start'}>
              {isUploading ? (
                <Text fontWeight={'500'} color="gray.600" fontSize={'13px'}>
                  Loading...
                </Text>
              ) : (
                <Image
                  src={imageUrl}
                  height="40px"
                  width="40px"
                  objectFit="contain"
                />
              )}

              <Button
                minHeight={'24px'}
                height={'24px'}
                onClick={onDelete}
                color="alert.primary"
                bg={'transparent'}
                fontSize="13px"
                padding={'0px'}
              >
                削除
              </Button>
            </VStack>
          </div>
        </FormControl>
      )}
    </HStack>
  )
}
